module.exports = __webpack_public_path__ + "static/tour@2x-028f64ea1cab2e273a4e7eb853eca975.png";